import { z } from "zod";

const SignupSchema = z.object({
  firstName: z.string({ required_error: "First name is required" }).min(1, "First name is required"),
  lastName: z.string({ required_error: "Last name is required" }).min(1, "Last name is required"),
  email: z
    .string({ required_error: "Email is required" })
    .email({ message: "Invalid email address" })
    .min(1, "Email is required"),
  password: z
    .string({ required_error: "Password is required" })
    .min(8, { message: "Password must be at least 8 characters long" }),
});

export default SignupSchema;
